module.exports = __webpack_public_path__ + "static/media/olovnePlombe3.7ae243f0.jpg";